import { render } from "./TelegramIcon.vue?vue&type=template&id=5efa6c94&scoped=true"
import script from "./TelegramIcon.vue?vue&type=script&lang=js"
export * from "./TelegramIcon.vue?vue&type=script&lang=js"

import "./TelegramIcon.vue?vue&type=style&index=0&id=5efa6c94&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5efa6c94"]])

export default __exports__